import React from "react";

const CopyFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M3.58983 1.66666H12.2437C13.3058 1.66666 14.1667 2.52765 14.1667 3.58973V12.2436C14.1667 13.3057 13.3058 14.1667 12.2437 14.1667H3.58982C2.52774 14.1667 1.66675 13.3057 1.66675 12.2436V3.58973C1.66675 2.52765 2.52774 1.66666 3.58983 1.66666Z"
        fill="#070B12"
      />
      <path
        d="M13.6539 15.8333H5.83342V16.4102C5.83342 17.4723 6.69441 18.3333 7.75649 18.3333H16.4103C17.4724 18.3333 18.3334 17.4723 18.3334 16.4102V7.7564C18.3334 6.69431 17.4724 5.83332 16.4103 5.83332H15.8334V13.6538C15.8334 14.8575 14.8576 15.8333 13.6539 15.8333Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default CopyFilledIcon;
